// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"63366c8d","160":"7724702c","208":"7068df9e","293":"8831f74b","453":"1407b060","493":"e87cee98","516":"8c246f03","519":"3cc88d63","917":"d5b094b2","946":"84c29544"}[chunkId] + ".chunk.js";
};